<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function() {
    function calculatorHeight() {
        if (window.innerWidth>550) {
            const ele = $('.sections-slide-show .has-categories.has-banner');
            if (ele.length > 0) {
                const eleHeight = $('.sections-slide-show .has-categories.has-banner .slideshow').height();
              
                $('.sections-slide-show .has-categories.has-banner .block-banner-slider').css('height', eleHeight);
            }
        }
    }

    calculatorHeight();

    // $(window).resize(function() {
    //     calculatorHeight();
    // });
});